/**
 * Monto bruto en moneda local (CLP). No usa meta.originalAmount (otra moneda).
 */
export function getDocumentGrossAmount(document) {
  if (!document) return 0;

  const currency = document.currencyType || 'CLP';
  const local =
    document.localAmount != null
      ? Number(document.localAmount)
      : document.meta?.exchange?.localAmount != null
        ? Number(document.meta.exchange.localAmount)
        : null;

  if (currency && currency !== 'CLP') {
    if (local == null || Number.isNaN(local)) {
      return 0;
    }
    return local;
  }

  if (local != null && !Number.isNaN(local)) {
    return local;
  }

  const amount = Number(document.amount);
  return Number.isNaN(amount) ? 0 : amount;
}

export const COST_CENTER_EPS = 1;

export function isCostCenterAssignmentComplete(gross, assignedSum) {
  if (gross <= COST_CENTER_EPS) return true;
  return Math.abs(assignedSum - gross) <= COST_CENTER_EPS;
}
